import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadBudgets = async () => {
  let response = await Axois.get('/budgets').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
}


export const loadBudget = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/budgetary-positions');
        const responseData = await requests.data;
        return {positions: responseData, budget: {}};
        // return { positions: [], budget: {}}
      
      default:
        let response = await Axois.get('/budgets/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return [];
    }
  }catch (err) {
    console.log(err);
  }
}



const useBudgetsAPI = () => {
  
  const save = async (data, success) => {
    try {
      const response = await Axois.post('/budgets', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('budget_response', data.seo);
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/budgets/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('budget_response', data.seo);
    }catch (err) {
      console.log(err);
    }
  }

  const processBudget = async (seo, data, success) => {
    try {
      const response = await Axois.patch('/budgets/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('budget_status', data.status);
    }catch (err) {
      console.log(err);
    }
  }

  return { save, update, processBudget };
}


export default useBudgetsAPI;